export const NO_IMG_URL = '/ekmps/assets/images/no-image.svg';
export const API_URL = '//search.ekm.net';
export const STICKER_API_URL = '/product/stickers'
export const PREDICTED_RESULT_SIZE = 4;
export const RESULT_PAGE_SIZE = 16;
export const RECENT_SEARCHES_KEY = 'ekm_recent_searches';
export const RECENT_SEARCHES_MAX = 5;
export const SEARCH_PAGE_MIN_SCORE = 0.1;
